/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */


(function( $ ) {
    "use strict";

    $( document ).ready(function() {

	// search
	$('.searchandfilter').on('change', function(){
	    $(this).submit();
	});

	$('.mobileSelect').on('change', function() {
            var selectedValue = $(this).val();
            $('input[type="radio"][value="' + selectedValue + '"]').prop('checked', true);
        });
	
	$('.searchandfilter').on('submit', function(event) {
	    var div_res = $(this).data('res');
            event.preventDefault(); // Prevent the default form submission
	    var urlajax = $(this).data('url');
	    var formData = new FormData(this);
	    formData.append('action', 'get_latest_articles');
	    var page = $('.page-numbers.sel');
	    var nb_page = 1;
	    if (page){
		nb_page = page.data('page');
		formData.append('paged', nb_page);
	    }

            $.ajax({
		url: urlajax,
		method: 'POST',
		data: formData,
		processData: false, 
                contentType: false, 
		success: function(response) {
                    // Faire quelque chose avec la réponse (par exemple, l'insérer dans une div)
                    $('#result_'+div_res).html(response);
		},
		error: function(xhr, status, error) {
                    console.error(xhr.responseText);
		}
            });
	});

	if ($('.searchandfilter')){
	    $('.searchandfilter').submit();
	}

	$('body').on('click', '.page-numbers', function(e) {	    
	    var type_search = $(this).data('search');
	    $('.page-numbers.'+type_search).removeClass('sel');
	    $(this).addClass('sel');
            e.preventDefault();
	    $('.searchandfilter.'+type_search).submit();
        });
	
	$('#mega-menu-wrap-menu-1 .obf span').each(function(){
	    const obfValue = $(this).attr('data-obf');
	    if (obfValue){
		const decodedUrl = atob(obfValue);
		
		const $a = $('<a>', {
		    href: decodedUrl,
		    text: $(this).text(),
		    //class: $(this).attr('class'),
		    //		id: $(this).attr('id')  
		});
		
		$(this).replaceWith($a);
	    }
	});
	
    });
    
}( jQuery ) );
